import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';

const { name } = STORE.modules.analysisClasses;

export default class AnalysisClasses extends Model {
  static entity = `${ name }`;

  static fields() {
    return {
      id: this.attr(null),
      name: this.string(''),
      analyses: this.attr([]),
    };
  }

  static methodConf = {
    http: {
      url: '/catalog/analysis_classes',
    },
  };
}
